// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox-module--wrapper--3chCb","error":"Checkbox-module--error--PsNR5","input":"Checkbox-module--input--175ct","checked":"Checkbox-module--checked--1NmMX"};